import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { PortfolioDetails, PortfolioDataForCreation } from "../../../model/finzy-flex/portfolio.model";
import { ConfigService } from "../../config.service";

@Injectable()
export class InvestmentService {
    private readonly httpClient: HttpClient;
    private readonly configService: ConfigService;

    constructor(
        httpClient: HttpClient,
        configService: ConfigService,
    ) {
        this.httpClient = httpClient;
        this.configService = configService;
    }

    async createAutoPortfolio(lenderId: string, autoPortfolioData: PortfolioDataForCreation): Promise<PortfolioDetails> {
        const url = `${this.configService.getLoanService_V2_Url()}/investment/${lenderId}`;
        return await this.httpClient.post<PortfolioDetails>(url, autoPortfolioData).toPromise();
    }

    async getFlexInvestmentAmount(lenderId: string): Promise<any> {
        const url = `${this.configService.getLoanService_V2_Url()}/investment/${lenderId}/flex-investment-amount`;
        return await this.httpClient.get<any>(url).toPromise();
    }

    async getMaxInvestmentAmount(lenderId: string): Promise<any> {
        const url = `${this.configService.getLoanService_V2_Url()}/investment/${lenderId}/max-investment-amount`;
        return await this.httpClient.get<any>(url).toPromise();
    }
}